import { TableColumn } from "../table/TableColumn";

const ReportColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 1,
        sortByName: "trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "name"
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 2,
        sortByName: "reportType.trnName",
        active: true,
        lookupName: "reportType.trnName",
        searchOnName: "reportType.id",
        translationKey: "type"
    },
    {
        heading: "Description",
        accessor: "description",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "description"
    },
    {
        heading: "Created By",
        accessor: "createdBy",
        isNumeric: false,
        id: 4,
        active: true,
        translationKey: "createdBy"
    },
]

export default ReportColumns;
